import React from 'react';
import { connect } from 'react-redux';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import { FETCH_DELAY, SENTRY_DSN, SETTINGS } from '../../config/constants';
import { fetchData, BAZEFIELD_FETCH_DATA_NEW } from '../../actions/Bazefield';

import Row from '../../components/Row';
import { APP_ENV } from '../../../../shared/config/constants';

if (APP_ENV !== 'development' && APP_ENV !== 'ci') {
  Sentry.init({
    dsn: String(SENTRY_DSN),
    integrations: [new Integrations.BrowserTracing()],
    attachStacktrace: true,
    tracesSampleRate: 1.0,
    environment: APP_ENV,
    allowUrls: [/^https?:\/\/[^/]+\/libraries\/hvc_widgets\//],
  });
}

class App extends React.Component {

  // static defaultProps = {
  //   status: BAZEFIELD_FETCH_DATA_NEW,
  //   error: null,
  // };

  constructor(props) {
    super(props);
    this.fetchDataCycle();
  }

  fetchDataCycle = () => {
    const { status, dispatch } = this.props;

    dispatch(fetchData(status));

    // Create an inteval to keep repeating the fetch task.
    if (status === BAZEFIELD_FETCH_DATA_NEW) {
      setInterval(this.fetchDataCycle, FETCH_DELAY);
    }
  };

  render() {
    return (
      <div className="u-text-center">
        <Row blocks={SETTINGS.blocks} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    status: state.measurements.getIn(['bazefield', 'status']),
    // error: state.measurements.getIn('bazefield', 'error'),
  };
};

export default connect(mapStateToProps)(App);
